import { render, staticRenderFns } from "./DashboardMenu.vue?vue&type=template&id=037edf0c"
import script from "./DashboardMenu.vue?vue&type=script&lang=js"
export * from "./DashboardMenu.vue?vue&type=script&lang=js"
import style0 from "./DashboardMenu.vue?vue&type=style&index=0&id=037edf0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports